/**
 * Theme Constants
 * Centralized theme colors and styling constants
 */

export const THEME_COLORS = {
  PRIMARY: '#4ce1b6',
  PRIMARY_HOVER: '#3dd1a3',
  PRIMARY_DARK: '#232329',
  PRIMARY_LIGHT: '#ffffff',
  DIVIDER_DARK: '#333246',
  DIVIDER_LIGHT: '#e0e0e0',
  TEXT_PRIMARY_DARK: '#ddd',
  TEXT_PRIMARY_LIGHT: 'rgb(88.3561643836, 91.0068493151, 105.1438356164)',
  TEXT_SECONDARY_DARK: '#999',
  TEXT_SECONDARY_LIGHT: 'rgb(88.3561643836, 91.0068493151, 105.1438356164)',
  BACKGROUND_DARK: '#12151c',
  BACKGROUND_LIGHT: '#f2f4f7',
  CARD_BACKGROUND_DARK: '#232329',
  SURFACE_ELEVATED_DARK: '#1a1e28',
  SURFACE_HEADER_DARK: '#161922',
  CARD_BACKGROUND_LIGHT: '#ffffff',
};

/**
 * App stacking scale.
 * Mobile shell raises MuiDrawer to DRAWER (1700). Select/Menu/Popover/DatePicker
 * use MUI theme.zIndex.modal — keep MODAL / DRAWER_MENU above DRAWER or menus open
 * invisibly behind drawers.
 */
export const Z_INDEX = {
  SIDEBAR: 100,
  HEADER: 101,
  MENU: 1800,
  POPOVER: 1800,
  TOOLTIP: 1900,
  DRAWER: 1700,
  DRAWER_BACKDROP: 1700,
  MODAL: 1800,
  MODAL_BACKDROP: 1800,
  DRAWER_MENU: 1800,
  DRAWER_POPOVER: 1800,
  MAXIMUM: 9999,
};

/** MUI theme.zIndex — menus/modals above drawers on mobile + desktop */
export const MUI_THEME_Z_INDEX = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: Z_INDEX.DRAWER,
  modal: Z_INDEX.DRAWER_MENU,
  snackbar: 1900,
  tooltip: Z_INDEX.TOOLTIP,
};

export const LAYOUT = {
  TOPBAR_HEIGHT: 60,
  DRAWER_WIDTH: 240,
  DRAWER_WIDTH_COLLAPSED: 60,
};

export default {
  THEME_COLORS,
  Z_INDEX,
  LAYOUT,
};

